import { PageBlockTypes as p } from '@xprog/prensa/types'

export const Template5050100: p.PageBlockProps = {
  css: {
    container: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      pt: '$0',
      width: 'calc(100% - $6)',
      '@lg': {
        width: '100%'
      }
    },
    columnHolder: {
      width: '100%',
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        maxWidth: '1280px',
        pt: '$4',
        width: '100%',
        '.Column:not(.ExtraTop,.Extra):nth-child(1)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(2)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(3)': {
          gridColumn: 'span 2',
          width: '100%'
        }
      }
    }
  },
  customProps: {
    container: {
      className: 'AlignToLeft'
    }
  }
}